import React from 'react'
import { zonedTimeToUtc } from 'date-fns-tz'
import { isAfter, isBefore, parse } from 'date-fns'
import { useFeatureFlag } from '@fs/zion-flags'
import useRootsTechBannerAnalytics from './useRootsTechBannerAnalytics'
import useRootsTechVisibility from './useRootsTechVisibility'

export default function RootsTechBannerBase({ featureFlag, visibility, startDate, endDate, children }) {
  useRootsTechBannerAnalytics()

  const { isOn } = useFeatureFlag(featureFlag || 'placeholder_flag') || {}
  const { shouldDisplay } = useRootsTechVisibility(visibility)
  const timeToShow = isDateInRange(startDate, endDate)

  if (!shouldDisplay || !timeToShow || (featureFlag && !isOn)) {
    return null
  }
  return <>{children}</>
}
function isEmpty(value) {
  return value === undefined || value === null || value === ''
}

function isDateInRange(startDate, endDate) {
  if (isEmpty(startDate) && isEmpty(endDate)) {
    return true
  }

  const timeZone = 'America/Denver'
  const formatString = 'M/d/yyyy h:mm a'
  const nowUTC = new Date()

  if (!isEmpty(startDate)) {
    const startFormatted = parse(startDate, formatString, new Date())
    const startTimeUTC = zonedTimeToUtc(startFormatted, timeZone)

    // If current time is before start date, don't show
    if (isBefore(nowUTC, startTimeUTC)) {
      return false
    }
  }

  if (!isEmpty(endDate)) {
    const endFormatted = parse(endDate, formatString, new Date())
    const endTimeUTC = zonedTimeToUtc(endFormatted, timeZone)

    // If current time is after end date, don't show
    if (isAfter(nowUTC, endTimeUTC)) {
      return false
    }
  }

  // If we got here, we're either after the start date, before the end date, or both
  return true
}
